import { Navigate } from 'react-router-dom';
import { useAuth } from '../Utils/Authorization'

export const Logout = (props) => {
  const auth = useAuth();
  sessionStorage.removeItem('spm-token');
  auth.setToken(null);

  return <Navigate to={'/'}/>
}